module.exports = __webpack_public_path__ + "media/images/emblems/La_Rippe-coat_of_arms-9d008c2be93ddba326f68ba38330abf5.svg";